import React, { ChangeEvent } from 'react';
import styles from '../widgetEditor.style';
import Select from '@vromo/ui/components/Select';
import { Widget } from '@vromo/models';
import { observer } from 'mobx-react-lite';
import { action } from 'mobx';

interface Props {
    checked?: boolean;
    disabled?: boolean;
    widget: Widget;
}

const WidgetTriggerSelector = observer(
    ({ checked, disabled, widget }: Props): React.ReactElement => (
        <>
            <label>
                <input
                    style={styles.checkbox}
                    type="checkbox"
                    disabled={disabled}
                    checked={checked || widget.settings.popup}
                    onChange={action(
                        (e: ChangeEvent<HTMLInputElement>) =>
                            (widget.settings.popup = e.target.checked)
                    )}
                />
                Popup
            </label>
            {(checked || widget.settings.popup) && (
                <>
                    <label>Show when</label>
                    <Select
                        value={widget.settings.when}
                        onChange={action(
                            (e: ChangeEvent<HTMLSelectElement>) =>
                                (widget.settings.when = e.target.value)
                        )}>
                        <option value="dispatched">Dispatched</option>
                        <option value="underway">Underway</option>
                        <option value="completed">Completed</option>
                        <option value="cancelled">Cancelled</option>
                        <option value="task0">Task 1</option>
                        <option value="task1">Task 2</option>
                        <option value="task2">Task 3</option>
                        <option value="task3">Task 4</option>
                    </Select>
                </>
            )}
        </>
    )
);

export default WidgetTriggerSelector;
